import { StateNode } from '@ansys-internal/awf-angular/store';

export class DisplayDataGraphResponseState implements StateNode<any> {
  key: string = 'displayDataGraphResponseState';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => any = () => ({});
}
